import React, { useEffect } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./styleCss/Shortcut.css";
import Swal from "sweetalert2";
import axios from "axios";
import { useState } from "react";
import Loading from "../components/loading/Loading";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import CardShortcutItem from '../components/cardShortcut/CardShortcutItem';

const cardDatas = [
    {
        path: "infoHeroBannerHome",
        classStyle: "card-sc01",
        iconUrl: "assets/icons/ic-sc-banner.png",
        title: "HERO",
        text: "BANNER",
    },
    {
        path: "infoCRCTower",
        classStyle: "card-sc02",
        iconUrl: "assets/icons/ic-sc-office.png",
        title: "OFFICE",
        text: "BUILDING",
    },
    {
        path: "infoRetailCenterDetail",
        classStyle: "card-sc03",
        iconUrl: "assets/icons/ic-sc-retail.png",
        title: "RETAIL",
        text: "CENTER",
    },
    {
        path: "infoCondoManage",
        classStyle: "card-sc04",
        iconUrl: "assets/icons/ic-sc-condo.png",
        title: "CONDOMINIUM",
        text: "ACCOMMODATION",
    },
    {
        path: "infoPromotion",
        classStyle: "card-sc05",
        iconUrl: "assets/icons/ic-sc-promotion.png",
        title: "PROMOTION",
        text: "& PRIVILEGE",
    },
    {
        path: "infoNews",
        classStyle: "card-sc06",
        iconUrl: "assets/icons/ic-sc-news.png",
        title: "NEWS",
        text: "& EVENT",
    },
    {
        path: "infoContentCareer",
        classStyle: "card-sc07",
        iconUrl: "assets/icons/ic-sc-career.png",
        title: "CAREER",
        text: "JOB",
    },
    {
        path: "infoBiddingInformation",
        classStyle: "card-sc08",
        iconUrl: "assets/icons/ic-sc-tendering.png",
        title: "TENDERING",
        text: "PROJECT",
    },
]

function Shortcut() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

    const cardShortcutElement = cardDatas.map((cardShortcut, idx) => {
        return <CardShortcutItem key={idx} card={cardShortcut}/>
    })

  return (
    <>
        <style>
        {`
            @media (min-height: 788px) { 
                .pdb-page {
                    padding-bottom: calc(15rem + 1px) !important;
                }
            }
        `}
        </style>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"SHORTCUTS"} />
        <Menu
            parentmenu={"infoShortcuts"}
            activemenu={"infoShortcuts"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs="4" className="d-flex align-items-center justify-content-start">
                            <img src="assets/icons/ic-shortcut.png" className="ic-title" alt="" />
                            <label className="m-0 fontLight font-size01 colorBlack01">
                                SHORTCUTS
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        {cardShortcutElement}
                    </Row>
                </div>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default Shortcut;